export default __webpack_public_path__ + "static/media/segforest.273bb2a7.webp";